import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';

const state = {
    /* Registro */
    bancosChequeras: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    bancoCuenta: null,
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.bancosChequeras = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.bancoCuenta = null;
    },

    'INICIALIZAR'(state) {
        state.bancosChequeras = [];
    },
    'SET_BANCOS_CHEQUERAS'(state, bancosChequeras) {
        state.bancosChequeras = bancosChequeras;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getBancosChequeras: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR')
            
            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;

            /*
            if (state.bancoCuenta) {
                if (state.bancoCuenta.id != 0) {
                    queryString += '&bancoCuentaId=' + state.bancoCuenta.id;
                }
            }
            */
    
            apiAxios.get('bancoschequeras' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        let params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_BANCOS_CHEQUERAS', res.data)

                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
            }, error => {
                reject(error);
            })
    },
    delete ( {}, bancoChequeraId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('bancoschequeras/' + bancoChequeraId + '/delete')
                .then(() => {
                    resolve();
                })
                .catch( error => {
                    var appError = false
                    var errorMessage = ''
                    if (error.response.status == 500) {
                        if (error.response.headers['application-error']) {
                            errorMessage = error.response.data
                        }
                    }
                    if (!appError) {
                        errorMessage = error.response.data
                    }          
                    reject(errorMessage)
                })
        }, error => {
            reject(error);
        })            
    },
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}